import React, { useEffect, useMemo, useState } from "react";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import StarRatingComponent from "react-star-rating-component";
import { Counter } from "../../MonCompte/MonComptePage/Panier/PanierPage";
import { FaShoppingCart } from "react-icons/fa";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import GaleryProduct, { images } from "./GaleryProduct";
import AvisProduct from "./AvisProduct";
import ProductSimilary from "./ProductSimilary";
import { useParams } from "react-router-dom";
import { useLazyProductBySlugQuery } from "../../../utils/api/product/product.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import { AppStorage } from "../../../utils/storage";
import { Color } from "../../../utils/theme";
import Swal from "sweetalert2";
import { onSetPanier } from "../../../redux/slice/User.slice";
import Fade from "react-reveal/Fade";
import { addCartProduct } from "../../../redux/slice/useCartSlice";
import {
  useAddProductCartMutation,
  useGetVendeurByApiKeyQuery,
} from "../../../utils/api/product/product.api";
import { useLazyFavoriteByUserQuery } from "../../../utils/api/favories/favorie.api";
import { ApiBaseUrl } from "../../../utils/http";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { formatCurrency,formatDecimal } from "../../../utils/Utils";
import { VendeurApikey } from "../../../utils/http";
import { getVendeur } from "../../HomePage/HomePage";

function hasDisplayableColor(c: unknown): boolean {
  if (c == null) return false;
  const s = String(c).trim();
  return s.length > 0;
}

function normalizeColorKey(c: unknown): string {
  if (c == null || c === "") return "";
  const s = String(c).trim().toLowerCase();
  if (!s.startsWith("#")) return s;
  if (s.length === 4) {
    return (
      "#" +
      s[1] +
      s[1] +
      s[2] +
      s[2] +
      s[3] +
      s[3]
    );
  }
  return s;
}

function isFalseLike(value: unknown): boolean {
  if (typeof value === "boolean") return value === false;
  if (typeof value === "number") return value === 0;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "false" || normalized === "0" || normalized === "non";
  }
  return false;
}

function isUnlimitedStock(
  stockFlag: unknown,
  fallbackFlag?: unknown
): boolean {
  return isFalseLike(stockFlag) || isFalseLike(fallbackFlag);
}

const ProduitItemPage = ({ min = 0, max = 5000, step = 1 }) => {
  const Vendeur = getVendeur();

  // const [item] = useProductFromLocation();
  const dispatch = useAppDispatch();

  const [item] = images;

  const { slug } = useParams<{ slug: string }>();
  const { user, token } = useAppSelector((s) => s?.user);
  const [showProfil, setShowProfil] = useState(true);
  const [variationActive, setVariationActive] = useState<any>();
  const [variations, setVariations] = useState<any>([]);
  const [validation, setValidation] = useState<boolean>(false);
  const [showValidation, setShowValidation] = useState<boolean>(false);
  const [validationColor, setValidationColor] = useState<boolean>(false);
  const [imagesProduit, setImagesProduit] = useState<any>();
  const [tailleActive, setTailleActive] = useState<any>();
  const [findBySlug, { data, isError, isLoading }] =
    useLazyProductBySlugQuery();
  const [findByFavorisSlug, { data: favoris }] = useLazyFavoriteByUserQuery();
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const navigate = useNavigate();
  const [count, setCount] = React.useState(1);
  const [addToCart] = useAddProductCartMutation();


  useEffect(() => {
    if (slug) {
      findBySlug(slug as string);
      findByFavorisSlug(user?.slug as string);
    }
  }, [slug]);

  const handalevalidation = () => {
    setValidation(false);
    setShowValidation(true);

    setTimeout(() => {
      setShowValidation(false);
    }, 3000);
  };

  useEffect(() => {
    if (!data) return;

    const firstVariation = data?.variations
      ?.filter((value, index, self) => {
        return (
          self.findIndex(
            (v) =>
              normalizeColorKey(v.couleur) ===
                normalizeColorKey(value.couleur) &&
              (isUnlimitedStock(value.stock_management, data?.stock_tracking) ||
                Number(value.quantite) > 0)
          ) === index
        );
      })
      ?.find(
        (v) =>
          isUnlimitedStock(v.stock_management, data?.stock_tracking) ||
          Number(v.quantite) > 0
      );

    if (
      data?.type === "taille_unique" ||
      data?.type === "taille_unique_avec_couleur"
    ) {
      setValidation(true);
      setShowValidation(false);
    }

    if (
      data?.type === "taille_variable" ||
      data?.type === "taille_variable_prix_unique"
    ) {
      setValidation(false);
      setTailleActive(undefined);
      setVariations([]);
      if (firstVariation) {
        setVariationActive(firstVariation);
      } else {
        setVariationActive(null);
      }
      return;
    }

    if (firstVariation) {
      setVariationActive(firstVariation);
      setVariations([firstVariation]);
    } else {
      setVariationActive(null);
      setVariations([]);
    }
  }, [data]);

  useEffect(() => {
    setImagesProduit(variationActive?.images);
  }, [variationActive]);

  const taillesDisponibles = useMemo(() => {
    if (!data?.variations?.length) return [];
    const isVarSize =
      data.type === "taille_variable" ||
      data.type === "taille_variable_prix_unique";
    if (isVarSize) {
      const activeKey = normalizeColorKey(variationActive?.couleur);
      const list = data.variations.filter((v) => {
        const isUnlimited = isUnlimitedStock(
          v.stock_management,
          data?.stock_tracking
        );
        if (!isUnlimited && Number(v.quantite) <= 0) return false;
        if (!activeKey) return true;
        return normalizeColorKey(v.couleur) === activeKey;
      });
      const byTaille = new Map<string, (typeof data.variations)[0]>();
      for (const v of list) {
        const t = String(v.taille ?? "").trim();
        if (!t) continue;
        if (!byTaille.has(t)) byTaille.set(t, v);
      }
      return Array.from(byTaille.values());
    }
    return data.variations.filter(
      (x) =>
        normalizeColorKey(x.couleur) ===
          normalizeColorKey(variationActive?.couleur) &&
        (isUnlimitedStock(x.stock_management, data?.stock_tracking) ||
          Number(x.quantite) > 0)
    );
  }, [data, variationActive]);

  const couleursDisponibles = useMemo(() => {
    if (!data?.variations?.length) return [];
    return data.variations
      .filter((value) => {
        const unlimited = isUnlimitedStock(
          value.stock_management,
          data?.stock_tracking
        );
        return unlimited || Number(value.quantite) > 0;
      })
      .filter((value) => hasDisplayableColor(value.couleur))
      .filter(
        (value, index, self) =>
          self.findIndex(
            (v) =>
              normalizeColorKey(v.couleur) === normalizeColorKey(value.couleur)
          ) === index
      );
  }, [data]);

  const promoActif = !!(
    data?.promotion?.is_active ||
    data?.categorie?.promotion?.is_active ||
    data?.sous_categorie?.promotion?.is_active
  );

  const tauxPromo = Number(
    data?.categorie?.promotion?.taux ||
      data?.sous_categorie?.promotion?.taux ||
      data?.promotion?.taux ||
      0
  );

  const localPriceRange = useMemo(() => {
    const candidates: number[] = [];
    const add = (raw: unknown) => {
      const n = Number(raw);
      if (Number.isFinite(n) && n > 0) candidates.push(n);
    };
    add(data?.prix);
    if (Array.isArray(data?.variations)) {
      data.variations.forEach((variation) => add(variation?.prix));
    }
    if (candidates.length === 0) {
      const fallback = Number(data?.prix);
      const safe = Number.isFinite(fallback) && fallback >= 0 ? fallback : 0;
      return { min: safe, max: safe };
    }
    return { min: Math.min(...candidates), max: Math.max(...candidates) };
  }, [data]);

  const promoPriceRange = useMemo(() => {
    if (!promoActif || tauxPromo <= 0) return localPriceRange;
    const applyPromo = (amount: number) => amount - (amount * tauxPromo) / 100;
    return {
      min: applyPromo(localPriceRange.min),
      max: applyPromo(localPriceRange.max),
    };
  }, [localPriceRange, promoActif, tauxPromo]);

  const isVariableTaillePrix =
    data?.type === "taille_variable" ||
    data?.type === "taille_variable_prix_unique";

  const afficherIntervallePrix = isVariableTaillePrix && !validation;

  const prixUnitaireBase = useMemo(() => {
    if (data?.type === "taille_unique") {
      const raw = parseFloat(String(data?.prix ?? 0));
      return Number.isFinite(raw) ? raw : 0;
    }
    const raw =
      variations?.[0]?.prix != null && variations[0].prix !== ""
        ? parseFloat(String(variations[0].prix))
        : parseFloat(String(data?.prix ?? 0));
    return Number.isFinite(raw) ? raw : 0;
  }, [variations, data?.prix, data?.type]);

  const prixUnitaireAffiche = useMemo(() => {
    if (promoActif && tauxPromo > 0) {
      return prixUnitaireBase - (prixUnitaireBase * tauxPromo) / 100;
    }
    return prixUnitaireBase;
  }, [prixUnitaireBase, promoActif, tauxPromo]);

  const renderPriceRange = (range: { min: number; max: number }) => {
    if (range.min === range.max) {
      return formatCurrency(range.min, Vendeur?.devise);
    }
    return `${formatCurrency(range.min, Vendeur?.devise)} - ${formatCurrency(
      range.max,
      Vendeur?.devise
    )}`;
  };

  const stockPourCompteur = useMemo(() => {
    if (data?.type === "taille_unique") {
      if (isUnlimitedStock(data?.stock_tracking)) return Number.POSITIVE_INFINITY;
      return Number(data?.stock ?? 0);
    }
    if (data?.type === "taille_unique_avec_couleur") {
      if (
        isUnlimitedStock(
          variationActive?.stock_management,
          data?.stock_tracking
        )
      ) {
        return Number.POSITIVE_INFINITY;
      }
      return Number(variationActive?.quantite ?? 0);
    }
    if (isVariableTaillePrix) {
      if (validation && variations[0]) {
        if (
          isUnlimitedStock(
            variations[0]?.stock_management,
            data?.stock_tracking
          )
        ) {
          return Number.POSITIVE_INFINITY;
        }
        return Number(variations[0].quantite ?? 0);
      }
      return 0;
    }
    if (isUnlimitedStock(variationActive?.stock_management, data?.stock_tracking)) {
      return Number.POSITIVE_INFINITY;
    }
    return Number(variationActive?.quantite ?? 0);
  }, [
    data?.type,
    data?.stock,
    variationActive,
    isVariableTaillePrix,
    validation,
    variations,
  ]);

  const peutAjouterAuPanier = useMemo(() => {
    if (count <= 0) return false;
    if (data?.type === "taille_unique") {
      if (isUnlimitedStock(data?.stock_tracking)) return true;
      return Number(data?.stock) > 0;
    }
    if (isVariableTaillePrix && !validation) {
      return taillesDisponibles.length > 0;
    }
    if (stockPourCompteur === Number.POSITIVE_INFINITY) return true;
    return stockPourCompteur > 0 && count <= stockPourCompteur;
  }, [
    count,
    data?.stock,
    data?.type,
    isVariableTaillePrix,
    validation,
    stockPourCompteur,
    taillesDisponibles.length,
  ]);

  function SuccessPopup() {
    Swal.fire({
      icon: "success",
      iconColor: Color.success,
      confirmButtonColor: Color.success,
      title: "Produit ajouté au panier avec succès !",
      showConfirmButton: false,
      timer: 3000,
    });
  }

  // Fonction pour ajouter un produit au panier
  const ajouterAuPanier = async () => {
    findBySlug(slug as string);

    const taux =
      data?.categorie?.promotion?.taux ||
      data?.sous_categorie?.promotion?.taux ||
      data?.promotion?.taux;

    const base =
      variations?.[0]?.prix != null && variations[0].prix !== ""
        ? parseFloat(String(variations[0].prix))
        : parseFloat(String(data?.prix ?? 0));
    const safeBase = Number.isFinite(base) ? base : 0;
    const prixLigne =
      promoActif && tauxPromo > 0
        ? safeBase - (safeBase * Number(taux ?? 0)) / 100
        : safeBase;

    const stockLigne =
      data?.type === "taille_unique"
        ? data?.stock
        : variations?.[0]?.quantite ?? variationActive?.quantite;

    let produit = {
      produit: data,
      prix: prixLigne,
      quantite: count,
      stock: stockLigne,
      variations: variations,
      vendeur: data?.vendeur?.id,
    };

    dispatch(addCartProduct(produit));
    SuccessPopup();
  };

  const onSelectColor = (item) => {
    setVariationActive(item);
    if (
      data?.type === "taille_unique" ||
      data?.type === "taille_unique_avec_couleur"
    ) {
      setVariations([item]);
      setValidation(true);
    } else {
      setValidation(false);
      setTailleActive(undefined);
      setVariations([]);
    }
  };

  const onSelectSize = (item) => {
    setTailleActive(item?.taille);
    setVariations([item]);
    setVariationActive(item);
    setValidation(true);
  };

  const ColorVariationItem = ({
    color,
    isActive,
    variation,
  }: {
    color: string;
    isActive?: boolean;
    variation?: any;
  }) => {
    return (
      <div
        className={
          variationActive?.id == isActive ? "btn_color_wrapper" : "btn_color"
        }
      >
        <label
          role="button"
          className={`btn btn_color_choose`}
          style={{ background: color }}
          onClick={() => onSelectColor(variation)}
        ></label>

        <input
          type="radio"
          name="variation_color"
          id="variation_color"
          value={variation?.id}
        />
      </div>
    );
  };

  const SizeVariationItem = ({
    size,
    variation,
  }: {
    size: string;
    variation: any;
  }) => {
    return (
      <label
        role="button"
        className={
          variation?.taille == tailleActive
            ? "btn btn_size_choose active "
            : "btn btn_size_choose"
        }
        onClick={() => onSelectSize(variation)}
      >
        <input
          type="radio"
          name="variation_size"
          id="variation_size"
          value={variation?.id}
        />

        {size}
      </label>
    );
  };


  const decrement = (e) => {
    setCount(prevValue => Number((prevValue - 1).toFixed(1)));
  };

  const increment = (e) => {
    setCount(prevValue => Number((prevValue + 1).toFixed(1)));
  };

  const handleChange = (e) => {
    const newValue = parseFloat(e.target.value);

    if (!isNaN(newValue)) {
      setCount(isNaN(newValue) ? 0 : newValue);
    } else {
      setCount(0);
    }
  };

  const handleAddFavoris = (id) => {
    let favorie = favoris?.find((x) => x?.produit?.id == id);

    let fd = new FormData();

    fd.append("user", user?.id);
    fd.append("produit", id);

    if (favorie) {
      axios
        .delete(ApiBaseUrl + `/api/favoris/${favorie?.slug}`, config)
        .then((response) => {
          findBySlug(slug as string);
          findByFavorisSlug(user?.slug as string);
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
        });
    } else {
      axios
        .post(ApiBaseUrl + "/api/favoris/", fd, config)
        .then((response) => {
          findBySlug(slug as string);
          findByFavorisSlug(user?.slug as string);
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
        });
    }
  };

  const onToggleFavorite = (id) => {
    if (!user?.slug) {
      Swal.fire({
        icon: "info",
        title: `Veuilliez vous connecter pour ajouter un produit au favoris .`,
        iconColor: Color.success,
        showConfirmButton: false,
        timer: 6000,
      });
    } else {
      handleAddFavoris(id);
    }
  };

  const isFavorite = (id) => {
    let favorie = favoris?.find((x) => x?.produit?.id == id);

    if (favorie) {
      return true;
    } else {
      return false;
    }
  };


  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content bg-white pb-5">
        <div className="container-easy-market">
          <Fade bottom>
            <div
              className="content-back-to pb-2 pt-3"
              onClick={(e) => {
                e?.preventDefault();
                navigate(-1);
              }}
            >
              <HiOutlineArrowLeft style={{ fontSize: 18 }} />
              <span className="ps-2 go-back-btn">RETOUR</span>
            </div>
          </Fade>
          {isLoading && (
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-3 dis-flex" key={0}>
                <div className="item-stat-dashboad-view ">
                  <div className="content-item-stat-dashboad-view mt-2">
                    <div className="content-item-icon-stat-dashboard-view">
                      <Skeleton className="img-icon-dash-view" width={`70%`} />
                      <Skeleton className="img-icon-dash-view" width={`70%`} />
                    </div>
                  </div>
                  <div className="content-stat-dashboard-view">
                    <div className="content-text-item-stat-dashboad-view">
                      <div className="icon-item-stat-dashboad-view">
                        <Skeleton
                          className="chiffre-item-stat-dashboad-view mb-1"
                          width={`50%`}
                        />
                        <Skeleton
                          className="chiffre-item-stat-dashboad-view mb-1"
                          width={`50%`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 mb-3 dis-flex" key={0}>
                <div className="item-stat-dashboad-view ">
                  <div className="content-item-stat-dashboad-view mt-2">
                    <Skeleton
                      className="titre-item-stat-dashboad-view mb-2"
                      width={`70%`}
                    />
                    <Skeleton
                      className="titre-item-stat-dashboad-view mb-2"
                      width={`50%`}
                    />
                    <Skeleton
                      className="titre-item-stat-dashboad-view mb-2"
                      width={`30%`}
                    />
                  </div>
                  <div className="content-stat-dashboard-view">
                    <div className="content-text-item-stat-dashboad-view">
                      <div className="icon-item-stat-dashboad-view">
                        <Skeleton
                          className="chiffre-item-stat-dashboad-view mb-1"
                          width={`50%`}
                        />
                        <Skeleton
                          className="titre-item-stat-dashboad-view mb-2"
                          width={`70%`}
                        />
                        <Skeleton
                          className="titre-item-stat-dashboad-view mb-2"
                          width={`50%`}
                        />
                        <Skeleton
                          className="chiffre-item-stat-dashboad-view mb-1"
                          width={`50%`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {!isLoading && (
            <div className="row row-product-item-page b-b-1 mb-3 pb-4">
              <div className="col-lg-6 col-md-12 col-left-product-item-page d-flex">
                <div className="content-col-left-product-item-page container-product-item-page">
                  <GaleryProduct
                    pictures={
                      data?.type == "taille_unique"
                        ? data?.images
                        : data?.variations && data?.variations[0]?.images
                        ? imagesProduit
                          ? imagesProduit
                          : data?.variations[0]?.images
                        : null
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-left-product-item-page d-flex">
                <div className="content-col-left-product-item-page container-product-item-page">
                  <Fade bottom>
                    <h1 className="name-prduct mb-2">{data?.nom}</h1>
                  </Fade>
                  <Fade bottom>
                    <p className="category-product-name mb-1">
                      Categorie: {data?.categorie?.nom}
                    </p>
                  </Fade>

                  <div className="custom_container container-product-description pb-4">
                    <Fade bottom>
                      <p className="custom_sm__title">Description</p>
                    </Fade>
                    <Fade bottom>
                      <pre className="text-describe-product-item-detail py-3">
                        {data?.description}
                      </pre>
                    </Fade>
                  </div>

                  <div className="custom_container container-product-price pb-4">
                    <Fade bottom>
                      {afficherIntervallePrix ? (
                        promoActif && tauxPromo > 0 ? (
                          <>
                            <span className="custom_sm__price_promos pb-3">
                              {renderPriceRange(promoPriceRange)}
                            </span>
                            <span className="custom_sm__price_promos_bare pb-3">
                              {renderPriceRange(localPriceRange)}
                            </span>
                          </>
                        ) : (
                          <p className="custom_sm__price pb-3">
                            {renderPriceRange(localPriceRange)}
                          </p>
                        )
                      ) : promoActif ? (
                        <>
                          <span className="custom_sm__price_promos pb-3">
                            {formatCurrency(prixUnitaireAffiche, Vendeur?.devise)}
                          </span>
                          <span className="custom_sm__price_promos_bare pb-3">
                            {formatCurrency(prixUnitaireBase, Vendeur?.devise)}
                          </span>
                        </>
                      ) : (
                        <p className="custom_sm__price pb-3">
                          {formatCurrency(prixUnitaireAffiche, Vendeur?.devise)}
                        </p>
                      )}
                    </Fade>
                  </div>
                  {couleursDisponibles.length > 0 ? (
                    <div className="custom_container variation_content container-product-colors pb-4">
                      <Fade bottom>
                        <p className="m-0 pb-2 custom_sm__title">Couleur</p>
                      </Fade>
                      <Fade bottom>
                        <div className="d-flex align-items-center gap-3 avalaible_colors_wrapper">
                          {couleursDisponibles.map((item, key) => (
                            <ColorVariationItem
                              color={item.couleur}
                              isActive={item.id}
                              variation={item}
                              key={key}
                            />
                          ))}
                        </div>
                      </Fade>
                    </div>
                  ) : null}
                  {data?.type != "taille_unique" &&
                  data?.type != "taille_unique_avec_couleur" ? (
                    <div className="custom_container variation_content container-product-sizes pb-3">
                      <Fade bottom>
                        <p className="m-0 pb-2 custom_sm__title">Taille</p>
                      </Fade>
                      <Fade bottom>
                        <div className="d-flex align-items-center gap-3 avalaible_sizes_wrapper">
                          {!!taillesDisponibles &&
                            taillesDisponibles.map((item, key) => (
                              <SizeVariationItem
                                size={item.taille}
                                variation={item}
                                key={key}
                              />
                            ))}
                        </div>
                      </Fade>
                    </div>
                  ) : (
                    ""
                  )}
                  {showValidation && (
                    <div className="alert alert-danger mt-1" role="alert">
                      Veillez choisir une taille
                    </div>
                  )}
                  <div className="container-quantite-produit mb-4">
                    <p className="title-quantity-product">Quantité</p>
                    {/* <div className="counter mt-3 mb-5">
                      <Counter setCount={setCount} count={count} produit={data} user={user} />
                    </div> */}
                    <div className="btn-wrap">
                      {count > 1 && (
                        <button
                          className="btn decrement-btn btn-counter-item"
                          disabled={count <= 1}
                          onClick={(e) => decrement(e)}
                        >
                          −
                        </button>
                      )}
                      {/* <div className="num">{count}</div> */}
                      <div className="num">
                        <input
                          type="number"
                          step="1"
                          value={count}
                          onChange={handleChange}
                          className="input-counter-item "
                        />
                      </div>
                      {stockPourCompteur === Number.POSITIVE_INFINITY ||
                      count < stockPourCompteur ? (
                        <button
                          className="btn increment-btn btn-counter-item"
                          onClick={(e) => increment(e)}
                        >
                          +
                        </button>
                      ) : null}
                    </div>
                  </div>
                  {(!isVariableTaillePrix || validation) &&
                    count > stockPourCompteur && (
                    <div className="alert alert-danger mt-1" role="alert">
                      {stockPourCompteur > 0
                        ? `La quantité maximale est de ${stockPourCompteur}`
                        : `Cette variation est en rupture de stock`}
                    </div>
                  )}
                  <div className="container-quantite-produit">
                    <p className="title-quantity-product">Total</p>
                    <p className="title-quantity-product">
                      {afficherIntervallePrix
                        ? promoActif && tauxPromo > 0
                          ? `${formatDecimal(
                              promoPriceRange.min * count,
                              Vendeur?.devise
                            )} - ${formatDecimal(
                              promoPriceRange.max * count,
                              Vendeur?.devise
                            )}`
                          : `${formatDecimal(
                              localPriceRange.min * count,
                              Vendeur?.devise
                            )} - ${formatDecimal(
                              localPriceRange.max * count,
                              Vendeur?.devise
                            )}`
                        : formatDecimal(
                            prixUnitaireAffiche * count,
                            Vendeur?.devise
                          )}
                    </p>
                  </div>
                  <div className="container-btn-add-to-cart-product mt-4">
                    <div className="content-btn-commande w-100">
                      <button
                        className="btn btn-theme-fav-product w-100"
                        onClick={(e) => onToggleFavorite(data?.id)}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-1 d-inline-block"
                              role="status"
                            ></span>
                          </>
                        ) : isFavorite(data?.id) ? (
                          <AiFillHeart style={{ color: "#DB242A" }} />
                        ) : (
                          <AiOutlineHeart />
                        )}

                        <span className="ps-2">
                          {" "}
                          {isFavorite(data?.id)
                            ? "Supprimer de vos favoris"
                            : "Favoris"}
                        </span>
                      </button>
                    </div>
                    <div className="content-btn-commande w-100">
                      {peutAjouterAuPanier ? (
                        <button
                          className="btn btn-theme-annim w-100"
                          onClick={() =>
                            validation ? ajouterAuPanier() : handalevalidation()
                          }
                        >
                          <span className="pe-2">AJOUTER AU PANIER</span>
                          <FaShoppingCart />
                        </button>
                      ) : (
                        <button
                          className="btn btn-theme-annim w-100"
                          disabled={true}
                        >
                          <span className="pe-2">AJOUTER AU PANIER</span>
                          <FaShoppingCart />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <AvisProduct product={data} />
          <ProductSimilary product={data} />
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default ProduitItemPage;
